<vb-ui-form-group labelClass="labelClass" [parentNgModel]="control">

	@if (label) {
		<label [id]="labelId" [class]="isSmallLabel ? 'smallLabel' : ''" #uiLabel>
			{{label}}
		</label>
	}

	<div uiControl role="group">
		<div class="btn-file" [class]="isSmallLabel ? 'smallInput' : ''" vbBtnPrimary fileUpload (onAdd)="setImageFile($event.file)">
			<span class="vb-icon vb-icon-center vb-icon-file"></span>
			{{ 'ChooseFile' | translate }}
			<input type="file" [attr.aria-labelledby]="labelId" [disabled]="isFileDisabled">
		</div>

		@if (url) {
			<div class="imagePreview">
				<img [src]="url" [alt]="label || ''" vbImageLoad>
				@if (!imageComponentMetadata.readOnly) {
					<span>
						@if (imageComponentMetadata.showDeleteButton) {
							<button type="button" (click)="clearSelectedImage()" vbBtnWhite>
								{{ 'Delete' | translate }}
							</button>
						}
						@if (imageComponentMetadata.showResetButton && value && !isDefaultImageSelected) {
							<button type="button" (click)="setDefaultImage()" vbBtnWhite>
								{{ 'ResetDefault' | translate }}
							</button>
						}
					</span>
				}
			</div>
		}
	</div>

	@if (control?.invalid) {
		<div role="alert" uiValidation>
			<div vbUiErrorMessage>
				@if (control.errors.required) {
					{{ 'ThisFieldIsRequired' | translate }}
				} @else if (control.errors.fileType) {
					{{ 'ImageSelector_FileExtensionError' | translate }}: {{ fileExtensions.join(', ') }}
				} @else if (control.errors.size) {
					{{ 'ImageSelector_SizeError' | translate : { '0': imageComponentMetadata.maxSize | fileSize } }}
				} @else if (control.errors.squareDimensions) {
					{{ 'ImageSelector_SquareDimensionsError' | translate }}
				}
			</div>
		</div>
	}
</vb-ui-form-group>

